export default function isFailureActionType(type) {
  if (/_REQUEST/.test(type)) return false
  if (!/FAIL/.test(type)) return false

  return !{
    FORM_CLEAR: true,
    FORM_REGISTER_INPUTS: true,
    FORM_INPUT_CHANGE: true,
    FORM_INPUT_FOCUS: true,
    FORM_INPUT_BLUR: true,
    FORM_VALIDATE_PASS: true,
    FORM_VALIDATE_FAIL: true,
    FORM_SUBMIT_PASS: true,
    FORM_SUBMIT_FAIL: true,
    FORM_BUTTON_PASS: true,
    FORM_BUTTON_FAIL: true,
    FEED_CLEAR: true,
    FEED_CLEAR_NEW: true,
    FEED_SET: true,
    FEED_ADD_EVENT: true,
    FEED_REMOVE_EVENT: true,
    ASSET_SEARCH_RECEIVE: true,
    ASSET_SEED_RECEIVE: true,
    BUILDER_CHECK_STATUS_RECEIVE: true,
    BUILDER_CHECK_STATUS_FAILURE: true,
    WATCHLIST_REFRESH_RECEIVE: true,
    WATCHLIST_REFRESH_FAILURE: true,
  }[type]
}
